export default __webpack_public_path__ + "static/media/construction.4eaa0a21.svg";